import { createAsyncThunk } from '@reduxjs/toolkit';

import { CountryResidenceService } from 'api';

export const addTaxResidency = createAsyncThunk(
	'registration/addTaxResidency',
	async (credentials: any, { rejectWithValue }) => {
		try {
			await CountryResidenceService.add(credentials);
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
